
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';

import PricingIntro from '../../resources/PricingIntro.svg';

import SpeciaLogo2 from '../../resources/circle specia 2.png';

import SpeciaLogo from '../../resources/speciaLogo.png';

import SecurityImg from '../../resources/Security.png';

import SpeciaLogoWithName from '../../resources/SpeciaLogoWithName.png';

import BGD from '../../resources/BGD1.png';

import TeamLogo from '../../resources/chart.png';

import PlayButton from '../../resources/playbutton.png';

import Cookies from 'universal-cookie';

import { Button } from 'react-bootstrap';
import { ButtonBase } from '@mui/material';
import TransparentButton from '../../utils/TransparentButton';

const plans = [
  {
    plan_id: 'payg',
    plan_name: 'Pay-as-you-go',
    description: 'Pay only for what you use. The final amount is calculated based on the number of clients you have each month',
  },
  {
    plan_id: 'fixed',
    plan_name: 'Fixed Price Model',
    description: 'The price is fixed for each month regardless of the number of clients',
  },
];

export default () => {
  const navigate = useNavigate();

  const auth = useAuth();

  const [
    searchParams,
    setSearchParams,
  ] = useSearchParams();
  const token = searchParams.get('token');

  const [
    status,
    setStatus,
  ] = useState(200);

  const [
    loading,
    setLoading,
  ] = useState(false);

  const [
    paymentPeriod,
    setPaymentPeriod,
  ] = useState('monthly');

  const cookies = new Cookies();

  const currentPath = cookies.get('currentPath') || '/';

  return (

    <>

      <div style={{ display: 'flex', flexDirection: 'column', width: '100vw', padding: '0', textAlign: 'center', alignItems: 'center', padding: '0 8vw' }}>

        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginTop: '8vw', marginBottom: '8vw' }}>
          <div style={{ flex: 1, textAlign: 'left', marginRight: '10vw' }}>
            <span style={{ fontSize: '1vw', padding: '0.4vw 0.8vw', border: 'solid 0.08vw rgb(0, 0, 0, 0.9)', borderRadius: '10vw', backgroundColor: 'rgb(255, 255, 255, 0.5)' }}>Pricing</span>

            <p style={{ fontSize: '3vw', marginTop: '1vw', marginBottom: '1vw' }}>Pre Built Agents for Accounting Firms</p>
            <p style={{ fontSize: '0.8vw', lineHeight: '1.7vw', letterSpacing: '0.06vw', marginBottom: '0' }}>Our pre-built agents are designed to handle key accounting workflows out of the box. Choose a plan that fits your firm’s needs and scale effortlessly—no custom development required.</p>
          </div>
          <div style={{ flex: 1 }}>
            <img style={{ width: '40vw' }} src={PricingIntro} />
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', padding: '1vw', borderRadius: '1vw', backgroundColor: '#F1E5D9' }}>
          {plans.map((plan, index) => (
            <div
              value={plan.plan_id}
              key={index}
              style={{ backgroundColor: 'rgb(255, 255, 255, 0.6)', alignItems: 'flex-start', textAlign: 'left', flexDirection: 'column', padding: '1.5vw 2.5vw', flex: 1, textAlign: 'left', borderRadius: '0.6vw', margin: '0', marginRight: index != plans.length - 1 ? '1vw' : 0, cursor: 'pointer' }}
            >
              <p style={{ fontSize: '1.6vw', fontWeight: '400', marginBottom: '1.1vw', paddingBottom: '1vw', marginTop: '0.5vw', borderBottom: 'solid 0.1vw rgb(0, 0, 0, 0.3)' }}>{plan.plan_name}</p>
              <p style={{ marginTop: '2vw' }}>
                {plan.plan_id == 'payg'
                  ? (
                      <>
                        <span style={{ fontWeight: '500', fontSize: '2vw' }}>$2</span>
                        <span style={{ fontWeight: '500', fontSize: '0.8vw' }}>
                          {' '}
                          /client per month
                          <span style={{ color: 'rgb(0, 0, 0, 0.4)' }}>($24 annually, billed monthly)</span>
                        </span>
                      </>
                    )
                  : (
                      <>
                        <span style={{ fontWeight: '500', fontSize: '2vw' }}>$3,000</span>
                        <span style={{ fontWeight: '500', fontSize: '0.8vw' }}> /month</span>
                      </>
                    )}
              </p>
              <p style={{ textAlign: 'left', fontSize: '0.8vw', height: '5.5vw', margin: 0 }}>{plan.description}</p>

            </div>
          ),
          )}
        </div>

      </div>

    </>
  );
};

